(function() {
    'use strict';
    
// By default, AngularJS will catch errors and log them to
// the Console. We want to keep that behavior; however, we
// want to intercept it so that we can also log the errors
// to the server for later analysis.
a3_cabin_reports.config(exceptionConfig);


    /**
    * @memberof CabinReports
    * @ngdoc config
    * @name exceptionConfig
    * @description 
    *   By default, AngularJS will catch errors and log them to
    *   the Console. We want to keep that behavior; however, we
    *   want to intercept it so that we can also log the errors
    *   to the server for later analysis.
    * @ngInject
    */
function exceptionConfig($provide) {
    $provide.decorator('$exceptionHandler', extendExceptionHandler);
}

    /**
    * @memberof exceptionConfig
    * @description 
    *   Override default exception handling and log errors 
    * @ngInject
    */	
function extendExceptionHandler($delegate, LogService) {
    return function(exception, cause) {
        $delegate(exception, cause);

        var exceptionMessage = (exception && exception.message) ? exception.message : String(exception || '');
        var isCalendarTemplateLoadCancellation = exceptionMessage.indexOf('$compile:tpload') >= 0
            && exceptionMessage.indexOf('views/calendar.html') >= 0
            && exceptionMessage.indexOf('p1=-1') >= 0;

        // Ignore expected template-load cancellation during route/login transitions.
        if (isCalendarTemplateLoadCancellation) {
            return;
        }

        /**
         * Could add the error to a service's collection,
         * add errors to $rootScope, log errors to remote web server,
         * or log locally. Or throw hard. It is entirely up to you.
         * throw exception;
         */
       LogService.error(exception, cause);
    };
}
    
})();